<script>

import Service from "../utils/general";
import PDFService from "../utils/pdf";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import axios from "axios";

export default {
    methods: {
        async generarComprobante() {
            const codigo = this.$route.params.codigo;

            const response = await axios.get(
                Service.getUrlAPI() + "admision/formPostulacion/" + codigo
            );

            let datos = response.data;

            let bodyPdf = await PDFService.bodyPDF(datos, datos.codigo);

            let docDefinition = {
                pageSize: "LETTER",
                pageMargins: [60, 90, 60, 40],
                header: PDFService.setting().header,
                footer: PDFService.setting().footer,
                content: bodyPdf,
            };

            // pdfMake.createPdf(docDefinition).open();
            pdfMake.createPdf(docDefinition).getBlob((blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = "FormularioPostulacion.pdf";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            });
        }
    },

    mounted() {
        this.generarComprobante();
    }
}
</script>
<style lang="css" scoped>
.theme--light.v-pagination .v-pagination__item:focus {
    outline: 0;
}
</style>